import React, { useState, useEffect, Fragment } from 'react';
import IntlMessages from '../../../../helpers/IntlMessages';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './table.scss';

import moment from 'moment';

export default function AriDatePicker({ getStartDate }) {
  const [startDate, setStartDate] = useState(moment());
  const [daysArr, setDaysArr] = useState([]);

  const daysArrGenerator = (startDate, stopDate) => {
    var arr = [];
    while (startDate < stopDate) {
      arr.push(moment(startDate));
      startDate = moment(startDate).add(1, 'days');
    }
    // console.log('object', arr);

    return arr;
  };

  useEffect(() => {
    setDaysArr(
      daysArrGenerator(moment(startDate), moment(startDate).add(30, 'days'))
    );
  }, [startDate]);

  const handldDateChange = date => {
    setStartDate(date);
    getStartDate(date);
  };

  const moveDays = (e, direction) => {
    e.preventDefault();
    if (direction === 'left') {
      setStartDate(pre => moment(pre).subtract(4, 'days'));
    }
    if (direction === 'right') {
      setStartDate(pre => moment(pre).add(4, 'days'));
    }
  };

  return (
    <Fragment>
      <div className="fix">-</div>
      <div className="top">
        <div className="date-picker">
          <div className="form-group has-float-label">
            <DatePicker
              selected={startDate}
              onChange={date => handldDateChange(date)}
            />
            <IntlMessages id="forms.date" />
          </div>
        </div>
        <div className="date-chevron">
          <FontAwesomeIcon
            icon={faChevronLeft}
            onClick={e => moveDays(e, 'left')}
          />
        </div>
        <div className="date-chevron">
          <FontAwesomeIcon
            icon={faChevronRight}
            onClick={e => moveDays(e, 'right')}
          />
        </div>
        <div className="date-list">
          <div className="date-blank">x</div>
          {daysArr.map((day, index) => (
            <Fragment>
              {day.format('ddd') === 'Sat' || day.format('ddd') === 'Sun' ? (
                <div className="date-cell-gray" key={index}>
                  <div>
                    {day.format('DD MMM')}{' '}
                    <b>({day.format('ddd').slice(0, 1)})</b>
                  </div>
                </div>
              ) : (
                  <div className="date-cell" key={index}>
                    <div>
                      {day.format('DD MMM')}{' '}
                      <b>({day.format('ddd').slice(0, 1)})</b>
                    </div>
                  </div>
                )}
            </Fragment>
          ))}
        </div>
      </div>
    </Fragment>
  );
}
